var exports = {
  "By": "x61f99309--afda3d--swipe",
  "FC": "x61f99309--afda3d--swipe--active",
  "Yn": "x61f99309--afda3d--swipe__content",
  "O1": "x61f99309--afda3d--swipe--outcoming",
  "ts": "x61f99309--afda3d--swipe__trail",
  "oi": "x61f99309--afda3d--swipe__bubbles",
  "yx": "x61f99309--afda3d--swipe__icon",
  "Au": "x61f99309--afda3d--swipe__hint",
};

module.exports = exports;
